import React, {ReactNode} from 'react';
import styled from 'styled-components';

type Props = {
    children: ReactNode,
}

const Bold = (props: Props) => {
    return (
        <BoldWithStyled { ...props }>
            { props.children }
        </BoldWithStyled>
    )
}

const BoldWithStyled = styled.span`
    font-weight: 700;
`;

export default Bold;